<template>
  <section
    v-touch:swipe.prevent="preventDesktop(swipe)"
    class="sidearm-mm-galleries bg-black h-100"
    data-anchor="gallery"
  >
    <button
      @click="toggle_photo_modal(true)"
      aria-label="view all galleries"
      class="sidearm-mm-galleries__modal-button text-uppercase hide-on-large-down"
      type="button"
    >
      View All
    </button>

    <div class="slide sidearm-mm-galleries__intro relative">
      <div
        class="sidearm-mm-galleries__content flex flex-align-stretch h-100 w-100 relative"
      >
        <div
          class="sidearm-mm-galleries__body text-white col-6-of-8 x-large-col-2-of-8 col-push-1 flex flex-column flex-justify-center flex-align-start"
        >
          <h3
            v-if="section.galleries && section.galleries.length"
            class="type-heading-large mb-1"
          >
            Last {{ section.galleries.length }} Photo Galleries
          </h3>
          <h4 v-if="section.title" class="type-hero mb-4">
            {{ section.title }}
          </h4>
          <p
            v-if="section.sub_title"
            class="type-paragraph-large ma-0 hide-on-medium-down"
          >
            {{ section.sub_title }}
          </p>

          <div class="hide-on-x-large hide-on-medium-down my-2"></div>

          <button
            @click="moveTo('gallery', 1)"
            type="button"
            class="sidearm-mm-btn --ghost hide-on-x-large"
          >
            <span class="mr-1">Explore Galleries</span>
            <icon>sf-arrows-thick-right --hint</icon>
          </button>
        </div>
      </div>
      <div
        class="sidearm-mm-galleries__divider h-100 absolute flex flex-justify-start hide-on-large-down"
      >
        <span></span>
      </div>
      <background-element
        class="sidearm-mm-galleries__top-background-element  col-1-of-8 absolute"
      />
      <background-element
        class="sidearm-mm-galleries__bottom-background-element  col-5-of-8 absolute"
      />
    </div>

    <slide-gallery
      v-for="(gallery, index) in section.galleries"
      :gallery="gallery"
      :index="index"
      :key="gallery.id"
    />

    <slide-gallery-transition class="hide-on-large-down" />

    <div
      scrolling
      :class="{
        'is-toggled': photo_modal_open
      }"
      class="sidearm-mm-galleries__photo-modal flex flex-column flex-align-stretch flex-justify-center"
      v-dom-portal
    >
      <button
        @click="toggle_photo_modal(false)"
        type="button"
        class="sidearm-mm-galleries__photo-modal-close type-paragraph-large text-bold"
        aria-label="Close all galleries"
      >
        <span class="pr-2">Close</span>
        <icon size="2.875rem">sf-close-minimal</icon>
      </button>
      <div
        class="sidearm-mm-galleries__photo-modal-content flex flex-column flex-align-center"
      >
        <h2 class="type-heading-bracket text-center mx-auto">
          Our Story - A Trip to the NCAA Tournament
        </h2>
        <p class="type-paragraph-large text-center ma-0 pt-2">
          Highlights from the {{ $root.year - 1 }}-{{ $root.year }} Season
        </p>
        <div
          class="sidearm-mm-galleries__photo-modal-galleries flex flex-align-stetch flex-justify-center flex-wrap"
        >
          <div
            class="col-4-of-8"
            v-for="gallery in section.galleries"
            :key="gallery.id"
          >
            <gallery-thumbnail :gallery="gallery" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import BackgroundElement from "@/components/Globals/BackgroundElement";
import SlideGallery from "@/components/Slides/SlideGallery";
import SlideGalleryTransition from "@/components/Slides/SlideGalleryTransitionDesktop";
import GalleryThumbnail from "@/components/GalleryThumbnail";

export default {
  name: "SectionGalleries",
  components: {
    BackgroundElement,
    SlideGallery,
    SlideGalleryTransition,
    GalleryThumbnail
  },
  data: () => ({
    photo_modal_open: false
  }),

  computed: {
    section() {
      if (!this.$root.data) {
        return null;
      }
      return this.$root.data.galleries_section;
    }
  },

  methods: {
    toggle_photo_modal(value) {
      if (value !== undefined) {
        this.photo_modal_open = !!value;
      } else {
        this.photo_modal_open = !this.photo_modal_open;
      }
    },

    swipe(direction) {
      if (direction === "left") {
        this.swipeLeft();
      }
    },

    swipeLeft() {
      this.moveSlideRight();
    }
  }
};
</script>
<style lang="scss">
.sidearm-mm-galleries {
  .fp-slidesNav {
    @include reset-slides-nav;
    opacity: 1;
    transition: opacity 0.7s;
    &.fp-bottom {
      bottom: #{grid_percent(120)};
    }
    ul {
      display: flex;
      justify-content: center;
      width: 25%;
      margin-left: 75%;
      li {
        padding-right: 18px;
        position: relative;
        overflow: hidden;
        &:first-child,
        &:last-child {
          display: none;
        }
        &::after {
          position: absolute;
          top: 50%;
          left: calc(1.5rem);
          width: 100%;
          height: 1px;
          content: "";
          border-top: dashed 1px $color-white;
        }
        a {
          margin-right: 0;
          transition: margin 0.3s;
          &.active {
            margin-right: 48px;
            span {
              border: dashed 1px $color-white;
              width: 100%;
              height: 100%;
            }
          }
          span {
            border: solid 3px $color-white;
            transition: border 0.3s, width 0.3s, height 0.3s;
          }
        }
      }
    }
  }

  .slide {
    transition: transform 0.7s;
    will-change: transform;
    &.active {
      + .sidearm-mm-gallery-transition {
        transform: translateX(-#{grid_percent(60)});
        &::before {
          height: calc(#{grid_percent(120)} + #{$header-height});
          opacity: 1;
          transform: none;
        }
        &::after {
          height: grid_percent(120);
          opacity: 1;
          transform: none;
        }
      }
    }
  }

  &__intro {
    &.active {
      + .slide {
        transform: translateX(-75%);
        .sidearm-mm-gallery__background {
          &::before {
            opacity: 0;
            transform: translateY(-#{grid_percent(120)});
          }
          &::after {
            opacity: 0;
            transform: translateY(#{grid_percent(120)});
          }
        }
        .sidearm-mm-gallery__fade-in {
          opacity: 0;
        }
      }
    }
  }

  @media (max-width: #{$breakpoint-x-large}) {
    .fp-slidesNav.fp-bottom {
      align-items: center;
      bottom: auto;
      display: flex;
      height: initial;
      justify-content: space-between;
      top: 120px;
      padding-left: grid_percent(120);

      &::before {
        -webkit-text-stroke: thin rgba($color-white, 0.8);
        color: transparent;
        content: "Gallery";
        font-family: $font-abolition;
        font-size: 1.875rem;
        font-weight: 400;
        letter-spacing: 0.25rem;
        line-height: 1;
        text-transform: uppercase;
      }

      ul {
        width: initial;
        margin-left: 0;

        li {
          a.active {
            margin-right: $spacer/2;
          }
        }
      }
    }
  }
}

body.fp-viewing-gallery-gallery-end,
body.fp-viewing-gallery-0 {
  .sidearm-mm-galleries {
    .fp-slidesNav {
      // opacity: 0;
    }
  }
}
</style>
<style lang="scss" scoped>
.sidearm-mm-galleries {
  &__modal-button {
    @include base-reset();
    color: $color-white;
    position: absolute;
    top: $header-height;
    margin-top: grid_percent(120);
    right: grid_percent(120);
    z-index: 4;
  }
  &__photo-modal {
    @include hide();
    position: fixed;
    transform: translateY(100%);
    z-index: 999;
    transition: transform 0.4s, height 0s 0.4s, left 0s 0.4s, top 0s 0.5s,
      width 0s 0.4s;
    &.is-toggled {
      @include unhide();
      overflow: hidden;
      transform: none;
      transition: transform 0.4s;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      .sidearm-mm-galleries__photo-modal-close {
        transform: none;
        transition: transform 0.5s 0.3s;
      }
    }
    &-close {
      @include base-reset();
      @include flex-item(0 0 auto);
      height: $header-height;
      width: 100%;
      background: rgba(0, 0, 0, 0.8);
      color: $color-white;
      padding: 0 12.5%;
      z-index: 1;
      text-align: right;
      transform: translateY(90%);
    }
    &-content {
      padding: grid_percent(120) 12.5%;
      @include flex-item(1 1 auto);
      background: $color-white;
      z-index: 2;
      overflow: auto;
    }
    &-galleries {
      padding-top: grid_percent(120);
      margin: 0 auto;
      width: 100%;
    }
  }
  &__top-background-element {
    top: $header-height;
    left: 0;
    height: calc((100% - #{$header-height}) * 0.375);
    z-index: 1;
  }
  &__bottom-background-element {
    bottom: 0;
    right: 0;
    height: calc(100% - #{$header-height});
    z-index: 1;
  }
  &__divider {
    position: absolute;
    top: 0;
    right: 0;
    width: 50%;
    z-index: 2;
    pointer-events: none;
    &::before {
      position: absolute;
      top: 0;
      left: 25%;
      width: 1px;
      height: calc(50% + #{$header-height/2});
      content: "";
      background: $color-white;
      transition: transform 0.4s 0.2s;
    }
    &::after {
      position: absolute;
      top: calc(50% + #{$header-height/2});
      left: 0.75rem;
      width: calc(25% - 0.75rem);
      height: 1px;
      content: "";
      background: $color-white;
      transition: width 0.2s 0s;
    }
    > span {
      position: absolute;
      top: calc(50% + #{$header-height/2});
      transform: translate(-50%, -50%);
      display: inline-block;
      border-radius: 50%;
      border: 1px solid $color-white;
      display: block;
      height: 1.5rem;
      width: 1.5rem;
    }
  }
  &__content {
    z-index: 2;
    padding-top: #{$header-height};
  }
  &__intro {
    z-index: 4;
    &.active {
      > .slide {
        transform: translateX(-75%);
      }
    }
  }

  @media (max-width: #{$breakpoint-x-large}) {
    &__intro.active {
      + .slide {
        transform: translateX(-100%);
      }
    }
  }
}
.sidearm-mm-galleries.active {
  .sidearm-mm-galleries__divider {
    &::before {
      transform: scaleY(0);
      transform-origin: bottom center;
      transition: transform 0.3s 0.7s;
    }
    &::after {
      width: 100%;
      transition: width 0.3s 1s;
    }
  }
}
</style>
